/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Button, MenuItem } from '@blueprintjs/core';
import { Icon } from '/components/icon';
import { Select } from '@blueprintjs/select';

export const WidgetRenderer = (widget, { handleClick, modifiers, index = 0 }) => {
	if (!modifiers.matchesPredicate) {
		return null;
	}
	return (
		<MenuItem
			cy-test={widget.key}
			key={index}
			active={modifiers.active}
			disabled={modifiers.disabled}
			onClick={handleClick}
			text={widget && widget.label}
			icon={widget.icon && <Icon icon={widget.icon} />}
		/>
	);
};

export const ChartDropdown = ({ onSelectionChanged, value, availableWidgets }) => {
	return (
		<Select
			items={availableWidgets}
			itemPredicate={(text, item) => item.label.indexOf(text) >= 0}
			itemRenderer={WidgetRenderer}
			noResults={<MenuItem disabled={true} text="No results." />}
			onItemSelect={onSelectionChanged}
			activeItem={value}
			popoverProps={{ minimal: true }}
		>
			<Button
				cy-test="widget-menu"
				icon={<Icon icon={value?.icon} />}
				rightIcon={'caret-down'}
				minimal
			>
				{value?.label}
			</Button>
		</Select>
	);
};
